import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ArrayService {
  sortBy(array, property) {
    return array.sort(function (a, b) {
      if (a[property] > b[property]) return 1;
      else if (a[property] < b[property]) return -1;
      return 0;
    });
  }

  removeDuplicates(array, property) {
    const unique = array.reduce(function(a,b){
      function indexOfProperty (a, b){
        for (let i=0;i<a.length;i++){
          if(a[i][property] == b[property]){
            return i;
          }
        }
        return -1;
      }

      if (indexOfProperty(a,b) < 0 ) a.push(b);
      return a;
    },[]);
    return unique;
  }

  specificElementOnTop(array, key, value) {
    var matchedValue = [];
    for (var i = 0, arrayLength = array.length; i < arrayLength; i++) {
      if (array[i][key] === value) {
        matchedValue.push(array[i]);
        array.splice(i, 1);
        break;
      };
    };
    matchedValue.forEach(v => array.unshift(v));
    return array;
  }
}
